import { api } from '../client';
import type { Maintenance } from '../types';

interface ListParams {
  all?: boolean;
  userId?: number;
  /** filtra manutenções vinculadas a um device específico */
  deviceId?: number;
  /** filtra manutenções vinculadas a um group */
  groupId?: number;
  /** apenas as não vinculadas a nada */
  refresh?: boolean;
}

/**
 * Endpoint /api/maintenance do Traccar.
 * No Traccar, "Maintenance" representa um alerta periódico baseado num
 * atributo da position (totalDistance, hours, engineHours, odometer, etc):
 * dispara quando o valor do atributo atinge `start + N * period`.
 */
export const maintenanceApi = {
  list: (params?: ListParams) => api.get<Maintenance[]>('/maintenance', { query: params }),
  create: (m: Partial<Maintenance>) => api.post<Maintenance>('/maintenance', { body: m }),
  update: (id: number, m: Maintenance) => api.put<Maintenance>(`/maintenance/${id}`, { body: m }),
  delete: (id: number) => api.delete<void>(`/maintenance/${id}`),
};
